/* @jsx h */
import { defineComponent, h } from "vue";
import { OrderDeliveryDetails } from "@lemmonhq/types";
import { OrderCardFieldValue as FieldValue } from "./FieldValue";
import { useLocalization } from "@lemmonhq/uikit";

interface OrderCardDeliveryInfoProps {
  delivery: OrderDeliveryDetails;
}

export const OrderCardDeliveryInfo =
  defineComponent<OrderCardDeliveryInfoProps>({
    name: "OrderCardDeliveryInfo",
    props: ["delivery"],
    setup(props) {
      const { t } = useLocalization();
      return () => {
        const { delivery } = props;

        return (
          <div>
            <div class="uppercase text-accent font-semibold mb-2">
              {t("orders.delivery.title")}
            </div>
            <div style="grid-template-columns: 70px 1fr;" class="grid text-xs">
              <FieldValue
                label={t("orders.delivery.name")}
                value={`${delivery.name}`}
              />
              <FieldValue
                label={t("orders.delivery.company")}
                value={delivery.company_name}
              />
              <FieldValue
                label={t("orders.delivery.street")}
                value={delivery.street}
              />
              <FieldValue
                label={t("orders.delivery.city")}
                value={delivery.city}
              />
              <FieldValue
                label={t("orders.delivery.zip")}
                value={delivery.postal_code}
              />
              <FieldValue
                label={t("orders.delivery.email")}
                value={delivery.email}
              />
              <FieldValue
                label={t("orders.delivery.phone")}
                value={delivery.phone}
              />
              {delivery.notes && (
                <FieldValue
                  label={t("orders.delivery.notes")}
                  value={delivery.notes}
                />
              )}
            </div>
          </div>
        );
      };
    },
  });
